import ScreenBarPartner from "./components/screen-bar-partner";
import Fireworks from "@fireworks-js/react";
import ScreenDonSection from "./components/screen-don-section";
import {useEffect} from "react";


/**
 * Écran "Custom YTB" (Yechiva de Sarcelles Village).
 *
 * ⚠️ AUTONOME : tout le style est défini INLINE dans ce composant (objets
 * `style={{}}` + le bloc <style> ci-dessous scopé par le préfixe `.ytb-`).
 * On ne dépend volontairement PAS des classes globales `.screen*` /
 * `.screenDon*` des fichiers CSS de thème (blue.css, etc.) ni de leurs
 * @font-face, pour garantir un rendu identique à la maquette quel que soit
 * le thème CSS configuré sur la campagne.
 */

// Bleu de la maquette (hardcodé volontairement, cf. décision produit).
const YTB = {
    deepBlue: "#122498",   // texte des cards + nombre objectif
    barFrom: "#1a2a9e",    // début du dégradé de la barre
    barTo: "#4a6ed8",      // fin du dégradé de la barre
    barTrack: "#cfe0f5",   // fond clair de la barre
    cardTop: "#dfe2f5",    // fond lavande du montant
    cardBottom: "#ffffff", // fond blanc du nom
}

// CSS local au composant : @font-face + structure + animations.
// Scopé sous `.ytb-screen` pour ne rien laisser fuir globalement.
const SCREEN_CSS = `
@font-face{
    font-family:"YTB-Manier-Bold";
    src:url("/campagne/screen/custom-ytb/Manier-Bold.otf");
}
@font-face{
    font-family:"YTB-Cerapro-Bold";
    src:url("/campagne/screen/custom-ytb/Cera-Pro-Bold.otf");
}
@font-face{
    font-family:"YTB-Cerapro-Thin";
    src:url("/campagne/screen/custom-ytb/Cera-Pro-Thin.otf");
}

.ytb-screen, .ytb-screen *{
    -webkit-touch-callout:none;
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
    box-sizing:border-box;
}

.ytb-screen-background{
    position:absolute;
    top:0;bottom:0;left:0;right:0;
    background-color:#0b1a6b;
}

.ytb-screen-content{
    position:absolute;
    top:0;bottom:0;left:0;right:0;
}

.ytb-don-card{
    height:15vh;
    min-width:18vw;
    max-width:18vw;
    border-radius:18px;
    overflow:hidden;
    position:relative;
    display:flex;
    flex-direction:column;
    box-shadow:0 6px 24px rgba(0,0,0,.25);
    animation-duration:2s;
    animation-fill-mode:both;
}

@keyframes ytbDonFadeIn{
    from{ left:3vw; opacity:0; }
    to{ left:0vw; opacity:1; }
}
.ytb-don-fade-in{ animation-name:ytbDonFadeIn; }
.ytb-don-fade-out{ display:none; }
`;


export default function CustomYTB({context, loading, campagneData})
{
    const screenOptions = campagneData?.screenOptions || {}
    const org = context.org

    useEffect(() => {
        document.body.style.overflow = "hidden";
        document.body.style.cursor = "none";
    }, []);


    if(loading)
    {
        return (
            <div className="ytb-screen" style={{aspectRatio: "16/9", position: "relative"}}>
                <style dangerouslySetInnerHTML={{__html: SCREEN_CSS}}/>
                <div className={"ytb-screen-background"}/>
            </div>
        )
    }


    return (
        <div className="ytb-screen" style={{aspectRatio: "16/9", position: "relative"}}>
            <style dangerouslySetInnerHTML={{__html: SCREEN_CSS}}/>

            <div className={"ytb-screen-background"}>
                <img src={"/campagne/screen/custom-ytb/bg.png"}
                     style={{height: "100vh", width: "100vw", objectFit: "cover"}} alt=""/>
            </div>

            <div className={"ytb-screen-content"}>
                <div style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                }}>

                    <div style={{marginTop: "12vh", width: "100%"}}>
                        <ScreenBarPartner context={context} campagneData={campagneData} colors={YTB} mini={screenOptions.barMini}/>
                    </div>


                    <div style={{marginTop: "6vh", width: "100%"}}>
                        <ScreenDonSection context={context} campagneData={campagneData} colors={YTB}/>
                    </div>


                    {screenOptions.forceCelebration && (
                        <Fireworks
                            autostart
                            options={{intensity: 30, particles: 100, traceLength: 1, opacity: 0.2}}
                            style={{
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                position: 'fixed',
                                background: 'transparent'
                            }}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}
